import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const errorLogService = {
    getAll,
};

const MODULE = {
    ACTIVITY_LOG: 'activity-logs',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll(filter) {
    const request = {
        params: {
            event: filter?.event,
            user: filter?.user,
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.ACTIVITY_LOG}`, request);
}